import React, { FC, memo } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';

interface Props {
  label: string;
  value?: string;
  small?: boolean;
  component?: JSX.Element;
  isColumn?: boolean; // special use case for product names
  noBorderBottom?: boolean; // special use case for product names
  padding?: string; // to control the padding if needed
}

const useStyles = makeStyles(() => ({
  textRow: {
    display: 'flex',
    justifyContent: 'space-between',
    rowGap: '.8em'
  },
  label: {
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center'
  }
}));

// This component is made as mobile versions of table rows
// It looks like this: Label --- Text/Component
export const Component: FC<Props> = ({
  label,
  value,
  component,
  noBorderBottom = false,
  small = false,
  isColumn = false,
  padding = '.8em 0'
}) => {
  const classes = useStyles();

  return (
    <div
      className={classes.textRow}
      style={{
        flexDirection: isColumn ? 'column' : 'row',
        borderBottom: noBorderBottom ? '0px' : '1px solid rgba(0,0,0,0.21)',
        padding: padding
      }}
    >
      <Grid container>
        <Grid xs={4}>
          <Typography
            className={classes.label}
            style={{ fontSize: small ? '.8em' : '1em', color: label==="" ? "transparent" : "black" }}
          >
            {label}:
          </Typography>
        </Grid>
        <Grid xs={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {/* We can either pass a jsx component here or plain text */}
          {component ? (
            component
          ) : (
            <Typography style={{ fontSize: small ? '.8em' : '1em' }}>
              {value || ''}
            </Typography>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export const TextRow = memo(Component);
